import { DataDispatchChannelEnum } from '../enums/data-dispatch-channel.enum';

/**
 * Data dispatch request DTO
 */
export class DataDiscpatchRequestDto {
	/**
	 * The channel to dispatch the notification through.
	 */
	channel!: DataDispatchChannelEnum;

	/**
	 * The primary recipient (e.g., email address, phone number).
	 */
	recipient!: string[];

	/**
	 * The content of the notification.
	 */
	payload!: {
		subject?: string;
		htmlBody?: string;
		textBody?: string;
		[key: string]: any;
	};

	/**
	 * Optional metadata for tracing and logging.
	 */
	metadata?: {
		source: string;
		correlationId?: string;
	};
}
